export enum LoginStatusEnum {
  SUCCESS,
  INVALID_CREDENTIALS,
  ERROR,
  NONE,
  BLOCKED,
  BLOCKED_WITH_REDIRECT,
  PASSWORD_RESET,
  WAITING,
}
